import CommonService from "../../services/commonService";
import LabourPlanningService from "../../services/labourPalnningService";
import CommonUtils from "../../utils/common.utils";
// import commonService from "../../services/commonService";
import { stat } from "fs";
import moment from "moment";

const state = {
	locations: [],
	categories: [],
	companyData: {},
	summary: {},
	tablePageCount: 0,
	idNameMap: [],
	categoryIdNameMap: [],
	promotion_product_list: [],
	reportLoader: false,
	labourData_store:[], 
	labourColData_store:[], 
	isLabourDataSHow: false,
	quickReportLabel: "iplh",
	labourCostDataType: null,
	reportSummaryData: [],
	reportCardLoad: false,
	customShiftsNameStore: [],
	promotion_product_list: [],
	loading_downloading_report: false,
	downloading_report_is_ready: false,
	downloading_report_count: 0, 
	department_list_data: [],
	daySchedulerStateData: {},
	storeDetailsProcessing: false,
	storeProcessingCompleted: false,
	downloading_report_title: 'Report',
	process_status: {
		allow_forecast: true,
        allow_autoschedule: true
	},
	polling_store: '',
	polling_date: '',
	companyConfigData: {},
};
const mutations = {
	SET_COMPANY_CONFIG_DATA(state, data) {
		state.companyConfigData = data;
	},
	QUICK_REPORT_LABEL(state, label){
		state.quickReportLabel = label;
	},
	SET_DAY_SCHEDULER_DATA(state, data){
		state.daySchedulerStateData = data;
	},
	LABOUR_DATA(state, data){
		state.labourData_store = data;
	}, 
	LABOUR_COL_DATA(state, data){
		state.labourColData_store = data;
	}, 
	SHOW_LABOUR_DATA(state, is){
		state.isLabourDataSHow = is;
	},
	LABOUR_DATA_TYPE(state, is){
		state.labourCostDataType = is;
	},
	REPORT_LOADER(state, isLoad){
		state.reportLoader = isLoad;
	},
	SET_PRODUCT_LIST(state, products){
		state.promotion_product_list = products;
	},
	SET_LOCATIONS(state, locations) {
		state.locations = locations;
	},
	SET_CATEGORIES(state, categories) {
		state.categories = categories;
	},
	SET_COMPANY_DATA(state, companyData) {
		state.companyData = companyData;
	},
	SET_SUMMARY(state, summary) {
		state.summary = summary;
	},
	TABLE_PAGE_COUNT: (state, payload) => {
		state.tablePageCount = payload;
	},
	ID_NAME_MAP: (state, payload) => {
		state.idNameMap = payload;
	},
	SET_LOADING_REPORT_STATUS(state, status) {
		state.loading_downloading_report = status;
	},
	SET_LOADING_REPORT_TITLE(state, title) {
		state.downloading_report_title = title;
	},
	SET_DOWNLOADING_REPORT_STATUS(state, status) {
		if(!state.downloading_report_count) {
			state.downloading_report_is_ready = status;
			setTimeout(() => {
				state.downloading_report_is_ready = false;
			}, 3000);
		}
	},
	SET_DOWNLOADING_REPORT_CLOSE(state) {
		state.downloading_report_is_ready = false;
	},
	ADD_DOWNLOADING_REPORT_COUNT(state, count) {
		state.downloading_report_count = count;
	},
	SET_DEPARTMENT_LIST_DATA(state, dept) {
		state.department_list_data = dept;
	},
	SET_POLLING_DETAILS(state, param) {
		state.polling_date = param.start_date;
		state.polling_store = param.outlet_id;
	},
	updateStoreDetailsProcessing: (state, payload) => {
		state.storeDetailsProcessing = payload;
	},
	updateStoreProcessingCompleted: (state, payload) => {
		state.storeProcessingCompleted = payload;
	},
	setProcessStatus: (state, payload) => {
		state.process_status = payload;
	},
};
const actions = {
	getLocations({ commit }, args) {
		return CommonService.getLocations(args)
			.then(response => {
				var locations = CommonUtils.insertIsSelectedKey(
					JSON.parse(response.data).results
				);
				commit("SET_LOCATIONS", locations);
				return "done";
			})
			.catch(error => {
				console.log(error);
			});
	},
	getCategories({ commit }) {
		CommonService.getClassification().then(response => {
			var categories = CommonUtils.insertIsSelectedKey(
				JSON.parse(response.data).results
			);
			commit("SET_CATEGORIES", categories);
		});
	},
	getCompanyConfig({ commit }) {
		Promise.all([
			CommonService.getCompanyConfig(),
			// CommonService.getCompanyLogo()
		])
		.then(([configResponse, logoResponse]) => {
			const companyConfig = JSON.parse(configResponse.data);
			// const companyLogo = JSON.parse(logoResponse.data);
	
			// Commit company config data to the store
			commit("SET_COMPANY_CONFIG_DATA", companyConfig);
	
			// Combine both data into a single object
			const combinedData = {
				config: companyConfig,
				logo: null
			};
	
			// Store combined data in local storage
			const dataString = JSON.stringify(combinedData);
			localStorage.setItem('company_config', dataString);
		})
		.catch(error => {
			console.error('Error fetching company data:', error);
		});
	},
	async getCompanyData({ commit }) {
		try {
			let companyData = {};
			await CommonService.getCompanyData()
			.then(response => {
				companyData = JSON.parse(response.data)
			}).catch((err)=>{
				console.error(err);
			});

			// Make sure the response is a valid JSON string
			let obj = {
				is_sb_malaysia: false,
				is_kfc: false,
				is_mcd: false,
				is_bk: false,
				is_bkasia: false,
				is_mcd_north: false,
				is_demo: false,
				is_bt: false,
				is_bb: false,
				is_dominos: false,
				is_gf: false,
				is_sb_india: false,
				is_third_wave: false,
			};

			// Define a map of company IDs to properties
			const companyMap = {
				'2d31e459-48ce-4449-9bed-25bda1a31b37': 'is_demo',
				'f6c561d2-5128-41ed-9afc-56e671283370': 'is_demo',
				'15e1f09e-acdb-43de-8009-db3e1bb5c1a1': 'is_sb_malaysia',
				'fbed1ee3-0c81-4776-a820-39dab08da547': 'is_mcd_north',
				'90953955-49c1-4e4d-ba85-fb0ca1bfaba2': 'is_bkasia',
				'a63eff5a-7f92-4cf5-95af-0212d05d0d88': 'is_kfc',
				'5bfb5014-8af3-4980-90fa-5d19dcad4679': 'is_bk',
				'2b712b21-ed49-469d-856b-1f0c87fac4be': 'is_mcd',
				'cd76efd9-2a1c-4910-90b2-83d365609205': 'is_dominos',
				'b21ac61a-6d19-4cf3-9aa7-a2e3cebf1da0': 'is_bt',
				'a1fe7751-f71a-413d-96fb-52dd068a2a01': 'is_bb',
				'86da239a-b840-4881-821b-f7462f9bc368': 'is_gf',
				'7563833f-1efe-4a9c-b7fa-76df9ffe094e': 'is_sb_india',
				'8b1e19d9-2d9b-433e-80c2-5de46e2c9410':'is_bt',
				'725cc6e0-658b-48d9-9039-794a23f18d99': 'is_third_wave'
			};

			// Set the appropriate property based on company ID
			const companyId = companyData.id;
			if (companyMap[companyId]) {
				obj[companyMap[companyId]] = true;
			}

			// Convert the object to a string
			const objString = JSON.stringify(obj);
			companyData.check_company = obj;
			commit("SET_COMPANY_DATA", companyData);

			// Set the object string in localStorage
			localStorage.setItem('check_company', objString);
			localStorage.setItem('company_id', companyId);
		} catch (error) {
			console.error("Error while fetching company data:", error);
		}
	},
	getSummary({ commit }, queryParams) {
		CommonService.getSummary(queryParams)
			.then(response => {
				commit("SET_SUMMARY", JSON.parse(response.data));
			})
			.catch(error => {
				console.log(error);
			});
	},
	setPromotionProductList({ commit }, products) {
		commit("SET_PRODUCT_LIST", products);
	},
	getPartnerSummaryAction({ commit }, reqParam) {
		state.reportCardLoad = true; 
		function addDays(date, daysToAdd) {
			var _24HoursInMilliseconds = 86400000;
			return new Date(date.getTime() + daysToAdd * _24HoursInMilliseconds);
		}
		var now = new Date();
		var yesterday = addDays(now, -1);
		var params = {};
		if(reqParam) {
			params = {
				start_date: reqParam.start ? reqParam.start : `${moment(yesterday).format("YYYY-MM-DD")}`,
				end_date: reqParam.end ? reqParam.end : `${moment(yesterday).format("YYYY-MM-DD")}`,
				filters: {outlets: reqParam.location ? reqParam.location : []}
			}
		} else {
			params = {
				start_date:  `${moment(yesterday).format("YYYY-MM-DD")}`,
				end_date: `${moment(yesterday).format("YYYY-MM-DD")}`,
				filters: {outlets:[]}
			}
		}

		LabourPlanningService.reportSummary(params)
			.then(response => {
				if (response.status === 200) {
					let res = JSON.parse(response.data);
					state.reportSummaryData = res;
				}
				state.reportCardLoad = false;
			})
			.catch(err => {
				state.reportCardLoad = false;
				console.log(err);
			});
	},
	getAllCustomShiftNamesAction({commit}, store_id) {
		LabourPlanningService.getAllCustomShifts(store_id)
		.then(response => {
			let responseData = JSON.parse(response.data);
			if(responseData.length) {
				state.customShiftsNameStore = [...responseData];
			} else {
				state.customShiftsNameStore = [
					{
						"name": "",
						"description": "",
						"start_time": "00:00:00",
						"end_time": "00:00:00"
					}
				];
			}
		}).catch(error => {
			console.error(error.response.data);
		});
	},
	addDownloadingReportCountAction({ commit }, name) {
		commit( 'SET_LOADING_REPORT_TITLE', name ? name : 'Report');
		commit( 'SET_LOADING_REPORT_STATUS', true)
		let cc = state.downloading_report_count;
		commit("ADD_DOWNLOADING_REPORT_COUNT", cc + 1);
	},
	removeDownloadingReportCountAction({ commit }, count) {
		let cc = state.downloading_report_count;
		commit("ADD_DOWNLOADING_REPORT_COUNT", cc - 1);

		var wait = function(condFunc, readyFunc, checkInterval) {
			var checkFunc = function() {
				if(condFunc()) {
					readyFunc(); 
				}
				else
				{
					setTimeout(checkFunc, checkInterval);
				}
			};
			checkFunc();
		};

		// Wait till downloading all files
		wait(
            function() { return state.downloading_report_count === 0; }, 
            function() { return commit( 'SET_LOADING_REPORT_STATUS', false), commit( 'SET_DOWNLOADING_REPORT_STATUS', true); },
            100
        );
	},
	abortDownloadingReportCountAction({ commit }, count) {
		let cc = state.downloading_report_count;
		commit("ADD_DOWNLOADING_REPORT_COUNT", cc - 1);
		if(state.downloading_report_count === 0) {
			commit( 'SET_LOADING_REPORT_STATUS', false);
		}
	},
	getProcessStatusAction({ commit }, param){
		return;
		LabourPlanningService.getProcessStatus({outlet_id: param.outlet_id, start_date: param.start_date}).then((res)=>{
			state.process_status = JSON.parse(res.data);
		}).catch((err)=>{
			console.error(err);
		});
	},
	startProcessStatusPolling({ commit, dispatch }, param) {
		// First check process status and return function
		if (localStorage.getItem('process_status')) {
			// Create a variable to hold the interval ID
			let intervalId = null;

			// Function to fetch process status and handle stopping
			const fetchAndCheckStatus = async () => {
				try {
					const res = await LabourPlanningService.getProcessStatus({ outlet_id: state.polling_store, start_date: state.polling_date });
					const processStatus = JSON.parse(res.data);
					// Assign value
					state.process_status = processStatus;
					// Check if any value is false
					if (Object.values(processStatus).every(value => value === true)) {
						// If all values are true, stop the interval
						clearInterval(intervalId);
						// Save process status in localhost
						localStorage.setItem('process_status', false);
						console.log('Polling stopped');
						window.location.reload();
					} else {
						localStorage.setItem('process_status', true);
					}
				} catch (err) {
					console.error(err);
				}
			};

			// Start polling every 20 seconds
			intervalId = setInterval(fetchAndCheckStatus, 10000);
		}
	}
};

export default {
	state,
	mutations,
	actions,
	namespaced: true
};
